var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"title":_vm.formatWifiPercentage}},[_c('i',{class:['fad', _vm.formatWifiIcon, 'mr-1']})])}
var staticRenderFns = []

export { render, staticRenderFns }